import { mapGetters, mapActions } from 'vuex'
import section from '@/api/section'
import person from '@/api/person'

import basicInfo from './basicInfo'
import displayInfo from './displayInfo'
import specificInfo from './specificInfo'
import specificInfoRb from './specificInfo-rb'
import autoSaveConfirm from './auto-save-confirm'
import user from '@/api/user'
export default {
  components: {
    basicInfo,
    displayInfo,
    specificInfo,
    specificInfoRb,
    autoSaveConfirm
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    },
    roleArr: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      isEdit: '',
      preEdit: '',
      nextEdit: '',
      showRank: false,
      showDegree: false,
      form: {
        hindexed: false,
        affiliations: [''],
        reviewJournals: ['']
        // keywords: ['']
      },
      type: '',
      isVisable: false,
      rules: {},
      sectionList: [],
      academicList: [],
      degreesList: [],
      journalList: [],
      eidtObj: {
        index: '',
        identity: false,
        sort: false
      }
    }
  },
  computed: {
    ...mapGetters({
      domain: 'getDomain',
      language: 'getLanguage',
      user: 'getUser',
      title: 'getTitle',
      country: 'getCountry',
      reviewType: 'getReviewType',
      editorialBoard: 'getEditorialBoard',
      degree: 'getDegree'
    })
  },
  watch: {
    data: {
      handler(val) {
        this.getData(val)
      },
      immediate: true
    }
  },
  mounted() {
    this.getSection()
    // this.getData()
  },
  methods: {
    async getData(data) {
      // const data = await person.query(this.$route.params.id)
      if (data) {
        const {
          // keyword,
          categoryList,
          affiliation,
          reviewJournal,
          degreesList,
          reviewerBoardMemberList,
          reviewerJournalList,
          rank
        } = data

        data.categoryIdList = categoryList
          ? categoryList.map(item => {
              return item.categoryId
            })
          : []
        data.degreesIdList = degreesList
          ? degreesList.map(item => {
              return item.id
            })
          : []
        data.reviewerBoardMemberIdList = reviewerBoardMemberList
          ? reviewerBoardMemberList.map(item => {
              return item.id
            })
          : []
        data.reviewerJournalIdList = reviewerJournalList
          ? reviewerJournalList.map(item => {
              return item.journalId
            })
          : []
        data.rankId = rank && rank.id
        if (data.eboradJournalList) {
          data.eboradJournalList.forEach(item => {
            item.sectionIdList = item.sectionList.map(val => {
              return val.id
            })
          })
        }
        data.affiliations = affiliation ? affiliation.split(';') : ['']
        data.reviewJournals = reviewJournal ? reviewJournal.split(';') : ['']

        this.form = data
      }
    },
    onEdit() {
      this.isEdit = true
      this.form = JSON.parse(JSON.stringify(this.user))
    },
    async getSection() {
      this.sectionList = await section.getAll()
    },

    async editInfo(index) {
      const id = this.$route.params.id
      if (
        index === 'basic' &&
        !this.user.codeList.includes('USER_MANAGE.MANAGE_USERS.PERSON.EDIT') &&
        this.user.codeList.includes(
          'USER_MANAGE.MANAGE_USERS.PERSON.EDIT_EXCEPT_EB_RB_GE'
        )
      ) {
        let info = {}
        if (this.type === 'manage-employees') {
          info = await user.query(id)
        } else {
          info = await person.query(id)
        }
        const roles = info.roleList.map(item => {
          return item.type
        })
        if (
          roles.includes('REVIEWER_BOARD') ||
          roles.includes('EDITORIAL_BOARD') ||
          roles.includes('GUEST_EDITOR')
        ) {
          this.$message.error({
            title: 'Error',
            content:
              'This reviewer is the [RB]/[EB]/[GE]. Please contact Website Editor to update the profile.'
          })
          return
        }
      }

      const preData = this.isEdit
      // console.log(preData, '迁移费')
      this.preEdit = preData
      this.nextEdit = index
      if (this.isEdit && this.isEdit != index) {
        this.isVisable = true
        return
      }
      this.isEdit = index
    },

    confirmSave() {
      const nextData = this.nextEdit
      // console.log(this.preEdit, this.nextEdit, 'preEdit')
      this.$refs[this.preEdit].save()
      this.isVisable = false
      this.isEdit = nextData
    },

    back() {
      this.isVisable = false
      this.isEdit = this.preEdit
    },

    // changeEditObj(index, key, val) {
    //   this.eidtObj.index = index
    //   this.eidtObj[key] = val
    // },
    cancel() {
      this.isEdit = ''
    },
    async confirm() {
      const data = await person.query(this.$route.params.id)
      this.getData(data)

      const nextData = this.nextEdit
      if (
        this.isEdit === this.nextEdit &&
        this.preEdit &&
        this.isEdit != this.preEdit
      ) {
        this.isEdit = nextData
        this.nextEdit = ''
        return
      }
      if (this.preEdit && this.isEdit != this.preEdit) {
        this.isEdit = nextData
        return
      }
      this.isEdit = ''
    }
  }
}
